/*
 * Public API Surface of @mmscan/mmscan-api-angular-client
 */

// Services
export * from './services/dealership.service';
export * from './services/territory.service';

// Configuration
export { MMSCAN_API_BASE_URL } from './mmscan-api.config';

// Vehicle / Manual types — re-exported from @mmscan/mmscan-api-types
export type { ManualDto, ManualGroupDto, ManualRevisionDto, ManualTypeDto, ModelDto } from '@mmscan/mmscan-api-types';
